export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export type SortOption = {
  direction: SortDirection;
  columnKey: string;
  sortBy: string | null;
};

export type SortByOptionType = {
  label: React.JSX.Element | string;
  value: string;
};

export type ColumnSortPopoverProps = {
  className?: string;
};
